module.exports = __webpack_public_path__ + "img/img-5.108d1845.png";